export default "__VITE_ASSET__Bk51dmZ2__"